import { render, staticRenderFns } from "./SvgLogoColor.vue?vue&type=template&id=7c4a2ce5"
var script = {}
import style0 from "./SvgLogoColor.vue?vue&type=style&index=0&id=7c4a2ce5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports